<template>
    <tr class="tr__registers">
        <td class="referencia">{{ reference }}</td>
        <td class="operacao">
            <div>
                <span  v-for="(label, index) in names" :key="label">
                    <p class="d-block" v-if="index == 0">{{ label }}</p>
                    <p class="d-block text-segund" v-else>{{ label }}</p>
                </span>

            </div>
            <span
                v-if="seeServicePlan()"
                @click="clickPlanoDeServico(workId)">
                <BtnOpenManual :isPreview="isPreview" :config="{ value: $t('module-budget.main-budget.operations.operations-row.service-plan-btn') }"></BtnOpenManual>
            </span>
        </td>
        <td class="hora text-center">
            <span v-if="isPreview">{{ editableHourValue.description }}: {{ editableHourValue.labor }}</span>
            <v-select
                v-else
                v-model="editableHourValue"
                :items="laborValues"
                return-object
                :label="$t('module-budget.main-budget.operations.operations-row.hour-price-label')"
                outlined
                dense
                hide-details="auto"
                menu-props="offset-y"
                @change="commitToStore"
            >
                <template slot="selection" slot-scope="data">
                    <span class="text-nowrap"> {{ data.item.description }}: {{ data.item.labor }} </span>
                </template>
                <template slot="item" slot-scope="data"> {{ data.item.description }}: {{ data.item.labor }} </template>
            </v-select>
        </td>
        <td class="tempo">
            <span v-if="isPreview">{{ hourTime }}</span>
            <v-menu v-else
                ref="hours"
                v-model="hoursOne"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="hourTime"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
            >
                <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="hourTime"
                    :label="$t('module-budget.main-budget.operations.operations-row.time-label')"
                    append-icon="mdi-clock-time-four-outline"
                    readonly
                    outlined
                    dense
                    v-bind="attrs"
                    v-on="on"
                    @click:append="hoursOne = true"
                ></v-text-field>
                </template>
                <v-time-picker
                    v-if="hoursOne"
                    v-model="hourTime"
                    full-width
                    format="24hr"
                >
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="primary"
                        @click="hoursOne = false"
                    >
                        {{$t('cancel')}}
                    </v-btn>
                    <v-btn
                        text
                        color="primary"
                        @click="$refs.hours.save(hourTime)"
                    >
                        {{$t('ok')}}
                    </v-btn>
                </v-time-picker>
            </v-menu>

        </td>
        <td class="discount text-center">
            <span v-if="isPreview">{{ editableDiscount }}</span>
            <v-text-field
                v-else
                v-model="editableDiscount"
                type="number"
                @keypress="onlyNumberRule"
                min="0"
                max="100"
                :label="$t('module-budget.main-budget.operations.operations-row.discount-label')"
                outlined
                dense
                class="input-number"
                hide-details
                @input="commitToStore"
                :rules="descMaxRule"
                @change="ruleDescMax(editableDiscount)"
            ></v-text-field>
        </td>
        <td class="total">
            {{ computedTotalWithoutVAT == 0 ? '0,00 €' : computedTotalWithoutVAT | currency }}
        </td>
        <td class="actions" v-if="!isPreview">
            <div class="d-flex actions-div">
                <div class="edit" @click="$emit('edit-row-clicked-operation', workId)" v-if="String(workId).includes('-111')">
                    <img src="/images/_SVGs/bo/edit_pencil.svg" :alt="$t('module-budget.main-budget.operations.operations-row.edit-operation-alt-img')" onload="SVGInject(this)" width="15" height="20" class="circle"/>
                </div>

                <div class="delete" @click="$emit('delete-row-clicked', workId, entityPackageServiceId)">
                    <img src="/images/_SVGs/bo/remove.svg" :alt="$t('module-budget.main-budget.operations.operations-row.delete-operation-alt-img')" onload="SVGInject(this)" width="15" height="20" class="circle"/>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
import {hasPropertiesInObject} from '@src/utils/validations.js';

const requiredStringOrNumber = {
    type: [String, Number],
    required: true
};

export default {
    components: {
        BtnOpenManual: () => import('@components/b2b/widgets/BtnServicePlan.vue')
    },
    props: {
        rowIndex: { type: Number },
        isPreview: { type: Boolean },
        showServicePlan: { type: Boolean | String },
        itemMpId: requiredStringOrNumber,
        workId: requiredStringOrNumber,
        reference: requiredStringOrNumber,
        discount: requiredStringOrNumber,
        names: {
            /**
             * @description the name of an operation may consist in various operations that need to be shown
             *  [name, name, name, name]
             */
            type: Array,
            required: true
        },
        hourValue: {
            /**
             *  @param hourValue this has to have a similar format to that stored in laborValue in the store. so that it can match the :items list
             */
            type: Object,
            required: true,
            validator: function(object) {
                return hasPropertiesInObject(['labor', 'description', 'isFavourite', 'id'], object);
            }
        },
        duration: {
            type: Object,
            required: true,
            validator: function(object) {
                return hasPropertiesInObject(['hours', 'minutes'], object);
            }
        },
        description: String | Number,
        calculatedTime: { type: String | Number, default: 0},
        laborValues: Array | Object,
        korId: String | Number,
        korText: String,
        entityPackageServiceId: String | Number,
        switchCounter: Number,
        hourValueDefault: Object
    },
    data() {
        return {
            hoursOne: false,
            editableDiscount: this.discount,
            editableHourValue: this.hourValue,
            descMaxRule: [v => (v >= 0 && v <= 100) || this.$t('module-budget.main-budget.operations.rule-desc-max')],
            onMountCounter: 1,
            lastLabor: {},

            lastIamLabor: {},
            lastOeLabor: {},
            hourTime: '00:00',
        };
    },
    computed: {
        startedBy() {
            let checkLocalStorage = JSON.parse(localStorage.getItem('@datadrive:budgetStartedBy'));
            let budgetStartedBy = this.$store.getters['budget/getBudgetStartedBy'];
            if(checkLocalStorage.budgetName !== "") {
                budgetStartedBy = checkLocalStorage;
            }
            return budgetStartedBy.budgetName;
        },
        startedBySimpleRevision() {
            return this.startedBy == 'simple-revision';
        },
        startedByNextRevision() {
            return this.startedBy == 'next-revision';
        },
        startedByHistory() {
            return this.startedBy == 'history-budget';
        },
        computedLaborValues() {
            let labor = this.$store.getters['budget/getB2bLaborValues'];
            labor = labor.filter(el => el.isActive === true);
            return labor;
        },
        computedTotalWithoutVAT() {
            const totalWithoutDiscount = +this.editableHourValue.labor * (+this.duration.hours + +this.duration.minutes / 60);
            return this.editableDiscount > 0 ? totalWithoutDiscount * (1 - this.editableDiscount / 100) : totalWithoutDiscount;
        }
    },
    watch: {
        computedTotalWithoutVAT: {
            handler: function(newValue, oldValue) {
                return newValue;
            },
            immediate: true,
            deep: true,
        },
        laborValues: {
            handler: function(newValue, oldValue) {
                if(newValue && this.onMountCounter > 1) {
                    let newLaborValue = newValue;
                    if(!newValue[0].isIAM) {
                      newLaborValue = [this.hourValueDefault.oe];
                    }
                    const findLabor = newLaborValue.findIndex(e => e.quotationLaborId == this.editableHourValue.quotationLaborId);
                    if(findLabor <= -1) {
                        const findLaborLast = newValue.findIndex(e => e.quotationLaborId == this.lastLabor.quotationLaborId);
                        if(findLaborLast > -1) {
                            this.editableHourValue = this.lastLabor;
                            setTimeout(() => {
                                this.commitToStore();
                            }, 300);
                        } else {
                            if(this.$route.name === 'budget-summary-edit') {
                                const oeStateForFindLabor = this.$store.getters['budget/getBudgetSummary'].stateForTotalizersCalcsOE;
                                if(oeStateForFindLabor && oeStateForFindLabor.length > 0) {
                                    const findIndexOperation = oeStateForFindLabor.findIndex(o => o.workId == this.workId);
                                    if(findIndexOperation > -1) {
                                        if(oeStateForFindLabor[findIndexOperation].hourValue.isIAM == true) {
                                            const findOeFavourite = oeStateForFindLabor.find(op => op.hourValue.isIAM == false);
                                            if(findOeFavourite) {
                                                this.editableHourValue = findOeFavourite.hourValue;
                                            } else {
                                                this.editableHourValue = oeStateForFindLabor[findIndexOperation].hourValue;
                                            }
                                        } else {
                                            this.editableHourValue = oeStateForFindLabor[findIndexOperation].hourValue;
                                        }
                                    }
                                }
                                let checkIfIsIAM = newValue.filter(h => h.isIAM == true && h.isFavourite == true);
                                if(checkIfIsIAM && checkIfIsIAM.length > 0) {
                                    this.editableHourValue = newValue[0];
                                }
                            } else {
                                let findFavourite = newLaborValue.filter(e => e.isActive);
                                this.editableHourValue = findFavourite[0];

                                setTimeout(() => {
                                    this.commitToStore();
                                }, 300);
                            }
                        }
                    } else {
                      // if(this.$route.name === 'budget-summary') {
                      //   const getLabors = this.$store.getters['budget/getB2bLaborValue'];
                      //   const oeLabor = getLabors.value.find(l => l.isFavourite && !l.isIAM && l.isActive).labor;
                      //   let oeState = this.$store.getters['budget/getBudgetSummary'].stateForTotalizersCalcsOE;
                      //   oeState.forEach(op => {
                      //     if(!op.hourValue.isIAM) {
                      //       const newFinalValue = +op.hourValue.labor * (+op.duration.hours + +op.duration.minutes / 60);
                      //       const newValuePrice = +op.discount > 0 ? newFinalValue * (1 - op.discount / 100) : newFinalValue;
                      //       let newObj = {
                      //         ...op,
                      //         totalWithoutVAT: newValuePrice
                      //       }
                      //       this.$store.commit('budget/setBudgetPayloadForTotalizersCalcsOE', newObj);
                      //     } else {
                      //       const newFinalValue = +oeLabor * (+op.duration.hours + +op.duration.minutes / 60);
                      //       const newValuePrice = +op.discount > 0 ? newFinalValue * (1 - op.discount / 100) : newFinalValue;
                      //       let newObj = {
                      //         ...op,
                      //         totalWithoutVAT: newValuePrice
                      //       }
                      //       this.$store.commit('budget/setBudgetPayloadForTotalizersCalcsOE', newObj);
                      //     }
                      //   })
                      // }
                    }
                }
            }, deep: true, immediate: true,
        },
        editableHourValue: {
            handler: function(newValue, oldValue) {
                if(oldValue) {
                    if(oldValue.isIAM) {
                        this.lastIamLabor = oldValue;
                    } else {
                        this.lastOeLabor = oldValue;
                    }

                    if(newValue.isIAM && !oldValue.isIAM || !newValue.isIAM && oldValue.isIAM) {
                        this.lastLabor = oldValue;
                    }
                }
            },
            deep: true,
            immediate: true,
        },
        duration: {
            handler: function(newValue, oldValue) {
                this.hourTime = `${newValue.hours}:${newValue.minutes}`
            },
            deep: false,
            immediate: false,
        },
        hourTime: {
            handler: function(newValue, oldValue) {
                let split = newValue.split(':');

                this.duration.hours = split[0]
                this.duration.minutes = split[1]

                this.commitToStore()
            },
            deep: false,
            immediate: false,
        },
        switchCounter: {
          handler: function(newValue, oldValue) {
            if(this.$route.name === 'budget-summary-edit') {
                this.commitToStore()
            }
            },
            deep: false,
            immediate: false,
        }
    },
    methods: {
        seeServicePlan() {
            let checkLSQuotationType = JSON.parse(localStorage.getItem('@datadrive:budgetQuotationType'));
            return this.showServicePlan == 'ServiceWorkPosition'
                && ((!this.startedBySimpleRevision && this.startedByNextRevision) || (this.startedByHistory && checkLSQuotationType && checkLSQuotationType.id == 1))
                && this.rowIndex == 0
        },
        clickPlanoDeServico(planId) {
            if(this.isPreview) {
              return;
            }
            this.$store.commit('budget/setB2b', { maintenancePlanHtml: { show: true, id: planId } });
        },
        commitToStore() {

            let defaultsLabor = this.$props.hourValueDefault;
            if(this.editableHourValue.isIAM) {
              defaultsLabor.iam = this.editableHourValue;
            } else {
              defaultsLabor.oe = this.editableHourValue;
            }

            const operationRowValues = {
                ...this.$props,
                discount: this.editableDiscount,
                hourValue: this.editableHourValue,
                totalWithoutVAT: this.$options.filters.currency(this.computedTotalWithoutVAT, true, false),
                description: this.$props.description ? this.$props.description : '',
                calculatedTime: +(this.$props.duration.hours + '.' + this.$props.duration.minutes),
                hourValueDefault: defaultsLabor
            };
            this.$store.commit('budget/putOperationToBudgetSummary', operationRowValues);
            this.$emit('change-operation-copy-cart');
            if(this.editableHourValue.isIAM === true) {
                const payloads = {
                    iam: operationRowValues,
                }

                let findStateOfOE = this.$store.getters['budget/getBudgetSummary'].stateForTotalizersCalcsOE;
                if(findStateOfOE !== null && findStateOfOE !== undefined && findStateOfOE.length > 0) {
                    let filterOperationOEIndex = findStateOfOE.findIndex(o => o.workId == operationRowValues.workId);
                    if(filterOperationOEIndex > -1) {
                        findStateOfOE[filterOperationOEIndex].discount = operationRowValues.discount;
                        findStateOfOE[filterOperationOEIndex].duration = operationRowValues.duration;

                        // if(!findStateOfOE[filterOperationOEIndex]?.totalWithoutVAT) {
                            const totalWithoutDiscount = +findStateOfOE[filterOperationOEIndex].hourValue.labor * (+findStateOfOE[filterOperationOEIndex].duration.hours + +findStateOfOE[filterOperationOEIndex].duration.minutes / 60);
                            const newValue = operationRowValues.discount > 0 ? totalWithoutDiscount * (1 - operationRowValues.discount / 100) : totalWithoutDiscount;
                            // const newRoundValue = newValue;
                            findStateOfOE[filterOperationOEIndex]['totalWithoutVAT'] = this.$options.filters.currency(newValue, true, true);
                        // }

                        let op = findStateOfOE[filterOperationOEIndex];
                        this.$store.commit('budget/setBudgetPayloadForTotalizersCalcsOE', op);
                    }
                }

                this.$store.commit('budget/setBudgetPayloadForTotalizersCalcsIAM', payloads.iam);
            } else {
                const payloads = {
                    oe: operationRowValues,
                }

                this.$store.commit('budget/setBudgetPayloadForTotalizersCalcsOE', payloads.oe);
            }

            // update shoppingCart
            const pickShoppingCartCopyOperationsUpdate = this.$store.getters['budget/getShoppingCartCopy'].operations;
            const pickShoppingCartOriginalOperations = this.$store.getters['budget/getB2bCurrentShoppingCart'].operations;

            let maintenance = [];
            let repair = [];

            pickShoppingCartCopyOperationsUpdate.forEach(operation => {
                pickShoppingCartOriginalOperations.maintenance.forEach(m => {
                    if(operation.workId == m.workId && operation.itemMpId == m.itemMpId) {
                        maintenance.push(operation);
                    }
                })
                pickShoppingCartOriginalOperations.repair.forEach(r => {
                    if(operation.workId == r.workId && operation.itemMpId == r.itemMpId) {
                        repair.push(operation);
                    }
                })
            });

            this.$store.commit('budget/setShoppingCartOperationsMaintenance', maintenance);
            this.$store.commit('budget/setShoppingCartOperationsRepair', repair);
        },
        ruleDescMax(value) {

            if (value > 100) {
                this.editableDiscount = 100;
                this.commitToStore();
            }else if(value < 0){
                this.editableDiscount = 0;
                this.commitToStore();
            }
        },
        roundExactMethod (num, places) {
            if (!("" + num).includes("e")) {
                return +(Math.round(num + "e+" + places)  + "e-" + places);
            } else {
                let arr = ("" + num).split("e");
                let sig = ""
                if (+arr[1] + places > 0) {
                    sig = "+";
                }
                return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + places)) + "e-" + places);
            }
        },
        returnHourString() {
            let itemHours = this.duration.hours;
            let itemMinutes = this.duration.minutes;
            itemMinutes = String(itemMinutes);
            if(itemMinutes.length < 2) {
                itemMinutes = '0' + itemMinutes
            }
            return `${itemHours}h ${itemMinutes}m`
        },

        returnHour() {
            let itemHours = this.duration.hours;
            let itemMinutes = this.duration.minutes;
            itemMinutes = String(itemMinutes);
            if(itemHours.length < 2) {
                itemHours = '0' + itemHours
            }
            if(itemMinutes.length < 2) {
                itemMinutes = '0' + itemMinutes
            }
            return `${itemHours}:${itemMinutes}`
        }
    },
    mounted() {
        this.commitToStore();
        this.onMountCounter++;
        this.lastLabor = this.hourValue;

        this.hourTime = this.returnHour();
    }
};
</script>

<style lang="scss" scoped>
@import './table-style.scss';
.tempo{
    width: 110px !important;
    min-width: 110px !important;
    padding: 5px;
}
::v-deep .v-list-item--link:before {
    background-color: #fff !important;
}

.input-number{
    ::v-deep input{
        text-align: right;
    }
}

.text-segund {
    font-size: 12px;
    padding-left: 10px;
}

.actions {
    min-width: 30px !important;
    display: flex !important;
    justify-content: center;
    align-content: center;
}

.actions-div {
    margin-left: 15px;
    width: 60%;
    min-height: 30px !important;
    justify-content: space-around;
    align-items: center;

    div{
        display: flex;
        justify-content: center;
        width: 20px;
        height: 20px;
        border-radius: 10px;
    }
}

::v-deep  .delete {
    background-color: #d90b3b34;

    .circle{
        g {
            path{
                fill:#ff4747;
            }
        }
    }
}

::v-deep .edit {
    background-color: var(--v-primary-base);

    .circle{
        g {
            path{
                fill: #fff !important;
            }
        }
    }
}
</style>
